import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, resolvedTheme, toggleTheme } = useTheme();

  const getIcon = () => {
    if (theme === 'system') {
      return resolvedTheme === 'dark' ? '🌙' : '☀️';
    }
    return theme === 'dark' ? '🌙' : '☀️';
  };

  const getTitle = () => {
    if (theme === 'light') return 'Switch to dark mode';
    if (theme === 'dark') return 'Switch to system preference';
    return 'Switch to light mode';
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-gray-800 border border-border-light dark:border-dark-border"
      title={getTitle()}
      aria-label={`Current theme: ${theme}. ${getTitle()}`}
    >
      <span className="text-xl">{getIcon()}</span>
      {theme === 'system' && (
        <span className="ml-1 text-xs text-text-gray dark:text-dark-text-secondary">auto</span>
      )}
    </button>
  );
};

export default ThemeToggle;